module.exports = require('./helpers/bundle-url').getBundleURL('9iXDo') + "resume-public.96d0a3db.pdf" + "?" + Date.now();